module.exports = __webpack_public_path__ + "img/warning.67f3cd3d.png";